/**
 * EcosystemPage Component
 *
 * Top-level page for the "Insights" analytics section (/ecosystem route).
 * Renders the page heading and delegates all analytics content to the
 * EcosystemAnalytics component, which displays sector distribution,
 * regional coverage, and cross-sector collaboration gap analysis.
 *
 * This is one of the three primary navigation entry points alongside
 * the Ecosystem (org-browsing) and Discover pages. Note: the "Insights"
 * label is user-facing only; the route, component, and folder keep the
 * "ecosystem" name to avoid churn in the tenant-concept namespace.
 */
import React from 'react';
import { Container } from 'react-bootstrap';

import SEO from '@/components/common/SEO';
import { useEcosystem } from '@/shared/contexts/EcosystemContext';

import EcosystemAnalytics from './components/EcosystemAnalytics';
import './Ecosystem.css';

export default function EcosystemPage() {
    const { ecosystem } = useEcosystem();
    const ecosystemName = ecosystem?.name || 'RILE Connect';
    return (
        <>
            <SEO
                title="Insights"
                description={`Explore analytics and insights about ${ecosystemName}: sector distribution, regional coverage, and collaboration gaps.`}
                breadcrumbs={[
                    { name: 'Home', path: '/' },
                    { name: 'Insights', path: '/ecosystem' },
                ]}
            />
            <Container className="py-5">
                {/* Page header and description */}
                <h1 className="text-primary mb-2">Insights</h1>
                <p className="lead mb-4">
                    Explore ecosystem health through sector distribution,
                    regional coverage, cross-sector collaboration, and
                    partnership analysis.
                </p>

                {/* Analytics dashboard with charts and gap analysis */}
                <EcosystemAnalytics />
            </Container>
        </>
    );
}
